import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const StyledLoginForm = styled(Box)(() => ({
  mx: { lg: 5, md: 2, xs: 1, sm: 1 },
  sx: { mt: 1 },
}));
